<template>
  <v-card dark class="text-xs-center" style="height: 50px; max-width: 400px;">
    <v-card-text class="align-center caption"
      >地点カテゴリーは、地点を表示できません。</v-card-text
    >
  </v-card>
</template>

<script>
export default {
  name: 'AppSelectPoiLocationGroupMapModal',
}
</script>
